import { Typography } from '@eventbrite/marmalade';
import { FormattedMessage } from 'react-intl';
import styles from './OnlineLocation.module.scss';
import { LISTING_HEAP_IDS } from '@/src/listings/components/_shared/constants';
import { OnlineLinkIcon } from '@/src/listings/components/_shared/Icons';

interface Props {
  onlineEventUrl?: string;
}

export const OnlineLocation: React.FC<Props> = ({ onlineEventUrl }) => {
  return (
    <div className={styles.onlineLocation}>
      <Typography as="h4" className={styles.text}>
        <FormattedMessage
          id="Online event"
          defaultMessage="Online event"
          description="Label for online event location"
        />
      </Typography>
      {onlineEventUrl && (
        <a
          className={styles.link}
          href={onlineEventUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-heap-id={LISTING_HEAP_IDS.ONLINE_EVENT_ACCESS_BUTTON}
        >
          <OnlineLinkIcon className={styles.onlineLinkIcon} />
          <FormattedMessage id="Access link" />
        </a>
      )}
    </div>
  );
};
